// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/AfmlHero';
import Intro from '../components/AfmlIntro';
import Stats from '../components/AfmlCEO';
import Footer from '../components/Footer';

function AkijFlourMills() {
  return (
    <>
      <Intro />
      <Hero />
      <Stats />
      <Footer />
    </>
  );
}

export default AkijFlourMills;
